import { Fragment } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const HelperGroupRenderer = (props) => {
  const { id, isVisible, title, items, onGroupToggle, ...other } = props;

  return (
    <Fragment>
      <div className="help-page-helper-group">
        <div className="header">
          <div className="title">{title}</div>
          <div
            className={`k-icon ${isVisible ? "k-i-minus" : "k-i-add"}`}
            onClick={(e) => onGroupToggle(id)}
          />
        </div>
        {isVisible && (
          <div className="content">
            {items?.map((item, index) => (
              <div
                draggable="true"
                onDragStart={(e) =>
                  e.dataTransfer.setData("func", item.toAdd || item.content1)
                }
                key={index}
                className="help-page-item-helper"
              >
                <div className="title">{item.title}</div>
                <div className="content1">{item.content1}</div>
                <div className="content2">{item.content2}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Fragment>
  );
};

const HelperRenderer = (props) => {
  const {
    items,
    numericIsVisible,
    textIsVisible,
    dateIsVisible,
    dateTimeIsVisible,
    onGroupToggle,
    ...other
  } = props;
  const { t } = useTranslation();

  //get those applying on number
  let numericItems = items?.filter((e) => e.appliesTo == 2);
  let textItems = items?.filter((e) => e.appliesTo == 3);
  let dateItems = items?.filter((e) => e.appliesTo == 4);
  let dateTimeItems = items?.filter((e) => e.appliesTo == 5);

  return (
    <Fragment>
      {numericItems && numericItems.length > 0 && (
        <HelperGroupRenderer
          id={2}
          isVisible={numericIsVisible}
          items={numericItems}
          title={t("expressions.apply_to_number")}
          onGroupToggle={onGroupToggle}
        />
      )}
      {textItems && textItems.length > 0 && (
        <HelperGroupRenderer
          id={3}
          isVisible={textIsVisible}
          items={textItems}
          title={t("expressions.apply_to_text")}
          onGroupToggle={onGroupToggle}
        />
      )}
      {dateItems && dateItems.length > 0 && (
        <HelperGroupRenderer
          id={4}
          isVisible={dateIsVisible}
          items={dateItems}
          title={t("expressions.apply_to_date")}
          onGroupToggle={onGroupToggle}
        />
      )}
      {dateTimeItems && dateTimeItems.length > 0 && (
        <HelperGroupRenderer
          id={5}
          isVisible={dateTimeIsVisible}
          items={dateTimeItems}
          title={t("expressions.apply_to_datetime")}
          onGroupToggle={onGroupToggle}
        />
      )}
    </Fragment>
  );
};

export const HelpPage = (props) => {
  const {
    title,
    numericIsVisible,
    textIsVisible,
    dateIsVisible,
    dateTimeIsVisible,
    onGroupToggle,
    items,
    ...other
  } = props;

  const currentTheme = useSelector((state) => state.currentTheme);
  const appearance = useSelector((state) => state.appearance);
  const firstItemMarginTop = title ? 0 : "16px"; 
  let isHelper = false;

  console.log("items", items, items.current);

  let source = Array.isArray(items) ? items : items?.current;
  if (source && source.length > 0 && !source[0]?.icon) {
    isHelper = true;
  }
  return (
    <Fragment>
      <div className="help-page">
        {title && <div className="title">{title}</div>}
        {!isHelper &&
          source?.map((item, index) => (
            <div key={index} className="help-page-item">
              <item.icon
                className="external-icon"
                width={item.width}
                height={item.height}
              />
              <div className="content">{item.content}</div>
            </div>
          ))}
        {isHelper && (
          <HelperRenderer
            numericIsVisible={numericIsVisible}
            textIsVisible={textIsVisible}
            dateIsVisible={dateIsVisible}
            dateTimeIsVisible={dateTimeIsVisible}
            items={source}
            onGroupToggle={onGroupToggle}
          />
        )}
      </div>
      <style>
        {`
            .help-page{
              display: flex;
              flex-direction: column;
              align-items: stretch;
              height: 100%;
              width: 100%;
              border: ${currentTheme.pageHelpBorder};
              border-radius: ${currentTheme.pageBorderRadius};
              background-color: ${currentTheme.pageHelpBg};     
              overflow-y: auto;       
            }
  
            .help-page > .title
            {
              font-size: 22px;
              font-weight: 700;
              color: ${currentTheme.touchColor};
              padding: 6px 8px 16px 8px;
            }
  
            .help-page .help-page-item:nth-child(1)
            {            
              margin-top: ${firstItemMarginTop};
            }
  
            .help-page .help-page-item
            {
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 18px;
              border-bottom: 1px solid ${currentTheme.separatorColor};
            }
  
            .help-page .help-page-item .external-icon
            {
             ${
               appearance.isRightToLeft
                 ? "margin-left: 16px;"
                 : "margin-right: 16px;"
             } 
              color: ${currentTheme.touchColor};
            }
            
            .help-page .help-page-item .external-icon path
            {
              fill: ${currentTheme.touchColor};
            }     
  
            .help-page .help-page-item content
            {
              
            }

            .help-page .help-page-helper-group .header
            {
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 8px 8px 8px 8px;
              border-bottom: 1px solid ${currentTheme.separatorColor};
            }

            .help-page .help-page-helper-group .header .k-icon:hover
            {
              cursor: pointer;
            }

            .help-page .help-page-helper-group .header .title
            {
              font-weight: 600;
              font-size: 15px;
            }

            .help-page .help-page-helper-group .content .help-page-item-helper
            {
              display: flex;
              flex-direction: column;
              padding: 10px;
              border-bottom: 1px solid ${currentTheme.separatorColor};
            }

            .help-page .help-page-helper-group .content .help-page-item-helper:hover
            {
              cursor: grab;
            }

            .help-page .help-page-helper-group .content .help-page-item-helper .title
            {
              color: ${currentTheme.touchColor};
              font-weight: 500;
              font-size: 16px !important;
              padding-bottom: 7px;
            }

            .help-page .help-page-helper-group .content  .help-page-item-helper .content1
            {
              font-weight: 500;
              font-size: 13px;
              padding-bottom: 9px;
            }

            .help-page .help-page-helper-group .content  .help-page-item-helper content2
            {
              padding-bottom: 20px;
            }
  
            `}
      </style>
    </Fragment>
  );
};
